<div id="layout-wrapper">

    <app-topbar-calc (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
    </app-topbar-calc>
  
    <app-sidebar-calc [isCondensed]="isCondensed"></app-sidebar-calc>
  
    <div class="main-content">
      <div class="page-content">
        <!-- content -->
        <router-outlet></router-outlet>
      </div>
  
      <!-- footer -->
    </div>
  </div>